module.exports = __webpack_public_path__ + "static/media/CyclingManIcon.4528911f.svg";